import { Component } from '@angular/core'

@Component({
    selector: 'sf-sidebar-footer',
    templateUrl: './sidebar-footer.component.html',
    styleUrl: './sidebar-footer.component.scss',
    host: {
        class: 'sidebar-footer border-top d-none d-lg-block',
    },
})
export class SidebarFooterComponent {}
